export default __webpack_public_path__ + "static/media/whoweare.ea6ef480.png";